// Demo Agropur
export const demoagropur = {
  logo_image_url: 'demo/agropur.png',
  button_color: '#1997cc',
  button_font: `'Open Sans', sans-serif`,
  button_radius: 50,
  button_half_border_color: '#1997cc',
  button_outlined_as_default: false,
  text_font: `'Open Sans', sans-serif`,
  title_font: `'Playfair Display', serif`,
  title_color: '#162f53',
}

// Demo ATR
export const demoatr = {
  logo_image_url: 'demo/atr.png',
  button_color: '#2d3691',
  button_half_border_color: '#2d3691',
  text_font: `'Open Sans', sans-serif`,
  title_font: `'Open Sans', sans-serif`,
}

// Demo Biblios
export const demobiblios = {
  logo_image_url: 'demo/biblios.png',
  logo_height: 100,

  body_background_color: '#222222',

  button_color: '#004280',
  button_half_border_color: '#292f37',

  text_font: `'Raleway', sans-serif`,
  title_font: `'Raleway', sans-serif`,
}

// Demo Chateau d'Arche
export const demo_chateaudarche = {
  body_background_color: '#fff',

  logo_image_url: 'demochateaudarche.png',
  logo_height: 140,

  token_hidden: true,

  button_color: '#B59971',
  button_hover_color: '#A4885E',
  button_hover_text_color: '#fff',

  button_outlined_hover_color: '#A4885E',
  button_font: `'Jost', sans-serif`,
  button_border_width: '1',

  button_text_uppercase: true,
  button_text_weight: 400,

  button_half_border_color: '#B59971',
  button_half_text_weight: 400,

  text_font: `'Jost', sans-serif`,
  text_weight: 300,

  title_font: `'Merriweather', sans-serif`,
  title_weight: 400,
  title_size: '25',

  subtitle_font: `'Magnite', cursive`,
  subtitle_color: '',
  subtitle_size: 0,
  subtitle_lineheight: 0,
  subtitle_weight: 0,
  subtitle_margin: 0,
  subtitle_text_transform: 'none',
}

// Demo CQIC
export const democqic = {
  logo_image_url: 'demo/cqic.png',
  logo_height: 115,
  button_radius: 10,
}

// Demo EB
export const demoeb = {
  logo_image_url: 'demo/eb.png',
}

// Demo Pareo
export const demo_pareo = {
  body_background_color: '#C0C3C2',

  logo_image_url: 'demo/pareo.jpeg',
  logo_height: 200,

  token_url: 'demo/pareo.jpg',
  token_width: 54,

  number_hidden: true,

  button_font: `'Montserrat', sans-serif`,
  button_color: '#6CB4BC',
  button_radius: 10,
  button_half_border_color: '#6CB4BC',
  button_text_letter_spacing: 1,
  button_text_weight: 600,
  button_text_size: 14,

  title_font: `'Roboto', sans-serif`,
  title_color: '#616161',
  title_uppercase: true,
  title_letter_spacing: 2,

  subtitle_font: `'Montserrat', sans-serif`,
  subtitle_size: 18,
  subtitle_color: '#FC5C5D',
  subtitle_uppercase: false,
  subtitle_letter_spacing: 1.5,

  text_font: `'Montserrat', sans-serif`,
  text_color: 'black',
}

// Demo Pierre et vacances
export const demo_pierreetvacances = {
  body_background_color: '#F9FBFB',

  logo_image_url: 'pierreetvacances.png',
  logo_height: 120,

  token_url: 'demo/pierreetvacances.png',
  token_width: 70,
  token_margin_top: -10,
  number_hidden: true,

  header_border_color: '#E9E9E9',

  button_color: '#d7532c',
  button_text_lineheight: 16,
  button_text_size: 14,
  button_text_weight: 500,
  button_radius: 20,

  button_half_border_color: '#E9E9E9',
  button_half_text_size: 14,

  text_font: `'Benton Sans', sans-serif`,
  text_color: '#3d4246',

  title_font: `'Poppins', sans-serif`,
  title_color: '#3D4246',
  title_size: 32,
  title_lineheight: 40,

  separator_color: '#E9E9E9',

  footer_border_color: '#E9E9E9',
  footer_background_color: '#006130',
  footer_text_color: 'white',
}

// Demo Sepaq
export const demosepaq = {
  logo_image_url: 'demo/sepaq.png',
  logo_height: 100,

  button_color: '#2095f2',
  button_text_uppercase: true,
  button_radius: 4,
  button_half_border_color: '#2095f2',

  text_font: `'Roboto', sans-serif`,
  title_font: `'Roboto', sans-serif`,
  text_color: 'black',
  title_uppercase: true,
}

// Demo SNFC
export const demo_snfc = {
  body_background_color:
    'linear-gradient(90deg, rgba(110,30,120,1) 0%, rgba(161,0,107,1) 23%, rgba(205,0,55,1) 69%)',

  logo_image_url: 'demo/snfc.png',
  logo_height: 100,

  token_hidden: true,
  number_hidden: true,

  button_color: '#0088ce',
  button_hover_color: '#0074af',
  button_hover_text_color: 'white',
  button_text_lineheight: 24,
  button_text_size: 18,
  button_text_color: 'white',
  button_text_weight: 700,
  button_radius: 7,

  button_half_border_color: '#333',
  button_half_text_color: '#0088ce',
  button_half_align_label_left: true,

  title_font: 'Avenir, Arial, sans-serif',
  title_weight: 400,
  title_color: ' #0088ce',
  title_size: 36,
  title_lineheight: 43,

  text_font: 'Avenir Book, Arial, sans-serif',
  text_color: '#4d4f53',
  text_size: 18,
  text_lineheight: 0,

  subtitle_color: '#333',
  subtitle_weight: 900,
  subtitle_size: 28,
  subtitle_lineheight: 33,

  legend_color: '#747678',

  footer_background_color: '#333',
  footer_text_color: 'white',
  footer_text_size: 14,
  footer_text_weight: 700,
}

// Demo Isabelle
export const isabelle = {
  body_background_color: '#dddddd',
  button_color: '#ef456f',
  button_radius: 50,
  button_half_border_color: '#1d1d1d',
}
